import { render, staticRenderFns } from "./TradeDetailDrawer.vue?vue&type=template&id=3b97905b&"
import script from "./TradeDetailDrawer.vue?vue&type=script&lang=js&"
export * from "./TradeDetailDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports